var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordCloudChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.974,
    height: 21.827,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3b5175",
    stroke: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21576",
    d: "M9.045 10.914h11.886v1.819H9.045Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21577",
    d: "M9.272 15.196h7.924v1.819H9.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21578",
    d: "M14.988 2.311a7.265 7.265 0 0 1 7.122 5.881l.234 1.219 1.222.221a4.982 4.982 0 0 1-.873 9.885H7.287a4.982 4.982 0 0 1-.878-9.884l1.223-.221.234-1.219a7.268 7.268 0 0 1 7.123-5.882m0-1.811a9.077 9.077 0 0 0-8.9 7.349 6.793 6.793 0 0 0 1.2 13.478h15.403a6.793 6.793 0 0 0 1.2-13.478A9.076 9.076 0 0 0 14.979.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordCloudChart);
export default __webpack_public_path__ + "static/media/word-cloud-chart.e4e8c0cacf1009fed00870c5b3eb8e9e.svg";
export { ForwardRef as ReactComponent };